import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  organizationRoles: [],
  allOrganizationRoles: [],
  totalPages: 0,
  totalRecords: 0,
  organizationRole: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_56: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_OrganizationRoles(state, organizationRoles) {
    state.organizationRoles = organizationRoles.items;
    state.totalPages = organizationRoles.totalPages;
    state.totalRecords = organizationRoles?.totalRecords ?? 0;
  },
  SET_AllOrganizationRoles(state, organizationRoles) {
    state.allOrganizationRoles = organizationRoles;
  },
  SET_OrganizationRole(state, organizationRole) {
    state.organizationRole = organizationRole;
  },
};
const actions = {
  errorOrganizationRole({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllOrganizationRoles({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OrganizationRoles/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllOrganizationRoles', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOrganizationRole', error);
      });
  },
  addOrganizationRole({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OrganizationRoles', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOrganizationRole', error);
      });
  },
  getOrganizationRole({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/OrganizationRoles/ById?organizationRoleId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_OrganizationRole', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOrganizationRole', error);
      });
  },
  editOrganizationRole({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OrganizationRoles/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOrganizationRole', error);
      });
  },
  deleteOrganizationRole({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/OrganizationRoles/Remove?organizationRoleId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOrganizationRole', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
